/* AM26 2026-08-05 — comportamentul barei de taburi Monkey Deals de pe PDP.
   Markup: snippets/am-pdp-offers.liquid. Stiluri: finalul lui
   am-bundle-offers.css. Patru responsabilități:

   1. SMOOTH SCROLL cu offset: click pe tab → scroll la secțiune, compensând
      headerul fixat + bara însăși (care va fi sticky în timpul scroll-ului).
      Ținta „Descriere" (secțiunea Shogun cu rich description v3) se rezolvă
      LA CLICK prin [id$="__shogun-below"] — id-ul complet conține
      template-id-ul temei și se schimbă la fiecare duplicare a temei; un id
      hardcodat e exact modul în care s-a rupt vechiul meniu (vezi comentariul
      istoric din product-sticky-menu.liquid).

   2. SCROLL-SPY: tabul secțiunii curente primește .is-active. Țintele se
      sortează după poziția REALĂ în document la fiecare evaluare (nu după
      ordinea taburilor) — pagina își schimbă layoutul după init (swiper,
      imagini lazy), deci pozițiile memorate la load ar minți.

   3. STICKY: când bara ar ieși din viewport pe sus, trece pe position:fixed
      sub headerul temei (.shopify-section-header.fixed), cu un spacer care
      îi ține locul în flux ca să nu sară layoutul.

   4. URMĂRIREA TABULUI ACTIV pe orizontală: pe ecrane înguste bara e mai
      lată decât viewportul (măsurat 545px conținut în 343px vizibili), deci
      ultimele taburi sunt în afara ecranului. Când scroll-spy schimbă tabul
      activ, bara alunecă exact cât să-l aducă în cadru. Vezi followActive(). */
(function () {
	'use strict';

	function init() {
		var nav = document.querySelector('.am-monkey-tabs');
		if (!nav || nav.amMonkeyBound) return;
		nav.amMonkeyBound = true;

		var tabs = Array.prototype.slice.call(nav.querySelectorAll('.am-monkey-tab'));

		/* Lanțuri de fallback per tab, rezolvate la fiecare apel (nu memorate):

		   „Descriere" — pe produsele cu rich description V3 conținutul stă în
		   secțiunea proprie `.am-rich-description` (începe cu .amy-hero, adică
		   exact hero video-ul), iar secțiunea Shogun e o COAJĂ GOALĂ de 0px
		   (guard-ul AM26 o suprimă) care pică fix pe „Produse recomandate" —
		   țintind-o, tabul ateriza pe recomandări (bug raportat de Tudor,
		   moștenit și de vechiul meniu pe toate produsele V3). Pe produsele
		   încă pe Shogun, secțiunea Shogun e cea reală — de aici fallback-ul.

		   „Specificații tehnice" — V3 are blocul complet `#amy-specs`
		   („Specificații complete", în rich description); acordeonul mic
		   `#tech-specs` din coloana de cumpărare e doar fallback-ul pentru
		   produsele fără V3 (tot bug raportat de Tudor: tabul ducea la
		   acordeonul închis, nu la specificațiile complete). */
		var CHAINS = {
			descriere: function () {
				return document.querySelector('.am-rich-description') ||
					document.querySelector('[id$="__shogun-below"]') ||
					document.getElementById('shogun-below');
			},
			specs: function () {
				return document.getElementById('amy-specs') || document.getElementById('tech-specs');
			}
		};

		function resolveTarget(tab) {
			var key = tab.getAttribute('data-am-target');
			var el = null;
			if (key && CHAINS[key]) {
				el = CHAINS[key]();
			} else {
				var href = tab.getAttribute('href') || '';
				el = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
			}
			/* o țintă randată dar goală (secțiunea Shogun suprimată de guard)
			   e la fel de moartă ca una absentă */
			if (el && el.offsetHeight === 0) el = null;
			return el;
		}

		/* Headerul vizibil care rămâne lipit: al temei sau, pe PDP-ul Black Friday, `.bf-hdr` (sticky, 65 px), cu
		   headerul temei ascuns — fără el bara de taburi se lipea la top 0, PESTE headerul BF (Tudor, 19.10). */
		function headerOffset() {
			var hs = document.querySelectorAll('.shopify-section-header, .bf-hdr');
			for (var i = 0; i < hs.length; i++) {
				var cs = getComputedStyle(hs[i]);
				if ((cs.position === 'fixed' || cs.position === 'sticky') && hs[i].offsetHeight) return hs[i].offsetHeight;
			}
			return 0;
		}

		/* ── sticky ── */
		var spacer = document.createElement('div');
		spacer.className = 'am-monkey-tabs-spacer';
		spacer.style.display = 'none';
		nav.parentNode.insertBefore(spacer, nav.nextSibling);
		var sentinel = document.createElement('div');
		nav.parentNode.insertBefore(sentinel, nav);

		/* HISTEREZIS (AM26 2026-08-13) — bug raportat de Tudor: „pot să dau
		   scroll up/down și se mișcă puțin elementele sus-jos, ceea ce face ca
		   tabul Monkey Deals să fie puțin cropat".

		   Cauza: pragul era același în ambele sensuri
		   (`sentinel.top < hOff`). Când sentinela se oprește la un pixel de
		   prag, lipirea e o buclă care se auto-întreține: `is-stuck` scoate
		   bara din flux și afișează spacerul → înălțimile se schimbă cu ~1px →
		   sentinela trece înapoi peste prag → se dezlipește → și tot așa, de
		   două ori pe secundă din intervalul de siguranță. Vizual: bara
		   tremură, iar tabul Monkey Deals (mai înalt decât restul — cap de
		   maimuță 28px) pare tăiat în timpul flip-ului.

		   Fix: praguri diferite pe cele două sensuri — se lipește la `hOff`,
		   dar se dezlipește abia după ce sentinela coboară cu încă 8px sub el.
		   Zona moartă e mai mare decât variația de layout produsă de flip, deci
		   starea nu se mai poate auto-declanșa. */
		var STICK_HYSTERESIS = 8;

		function updateSticky() {
			var hOff = headerOffset();
			var stuck = nav.classList.contains('is-stuck');
			var top = sentinel.getBoundingClientRect().top;
			/* lipit: rămâne lipit până trece clar sub prag; dezlipit: se lipește
			   exact la prag — altfel bara ar acoperi conținutul cu 8px întârziere */
			var shouldStick = stuck ? (top < hOff + STICK_HYSTERESIS) : (top < hOff);
			if (shouldStick && !stuck) {
				spacer.style.height = nav.offsetHeight + 'px';
				spacer.style.display = 'block';
				nav.style.top = hOff + 'px';
				nav.classList.add('is-stuck');
			} else if (!shouldStick && stuck) {
				nav.classList.remove('is-stuck');
				nav.style.top = '';
				spacer.style.display = 'none';
			}
			/* AM26 2026-08-28 — `top` NU se mai actualizează cât bara e lipită.

			   Înainte, ramura „rămâne lipit" rescria `nav.style.top =
			   headerOffset()` la FIECARE frame de scroll, iar `headerOffset()`
			   citeşte `offsetHeight`-ul headerului LIVE. Pe iOS headerul îşi
			   schimbă înălţimea în timpul scroll-ului (bara de adrese care se
			   pliază), deci `top` o urmărea 1:1 — măsurat 71→64→56→48 — şi bara
			   de taburi aluneca vizibil sus-jos. Exact ce a raportat Tudor.

			   O primă încercare a pus un prag de 1px pe rescriere. Codex a
			   arătat, corect, că nu rezolvă nimic: o colapsare reală a
			   headerului e de ~23px, cu mult peste prag, deci `top` continua
			   să urmărească înălţimea. Pragul filtra doar jitterul sub-pixel.

			   Fixul corect e să NU urmărim deloc: offsetul se îngheaţă în
			   momentul lipirii (ramura de mai sus) şi rămâne aşa cât timp bara
			   e lipită. O eventuală schimbare legitimă de înălţime a headerului
			   (rotire în peisaj, bară de anunţ închisă) e prinsă de handlerul
			   de `resize`/`orientationchange`, care recalculează — vezi
			   `refreshStickyOffset()` mai jos. */
		}

		/* ── scroll-spy ── */
		function updateSpy() {
			var probe = headerOffset() + nav.offsetHeight + 60;
			var current = null;
			var bestTop = -Infinity;
			tabs.forEach(function (tab) {
				var el = resolveTarget(tab);
				if (!el) return;
				var top = el.getBoundingClientRect().top;
				if (top <= probe && top > bestTop) {
					bestTop = top;
					current = tab;
				}
			});
			/* înainte de prima secțiune, activ rămâne primul tab */
			if (!current && tabs.length) current = tabs[0];
			tabs.forEach(function (tab) {
				var on = tab === current;
				tab.classList.toggle('is-active', on);
				if (on) { tab.setAttribute('aria-current', 'true'); }
				else { tab.removeAttribute('aria-current'); }
			});
			/* Se urmărește tabul activ când S-A SCHIMBAT sau când e (încă) în
			   afara cadrului. Doar `changed` nu ajunge: dacă utilizatorul intră
			   pe pagină deja în dreptul secțiunii, sau derulează lung prin
			   aceeași secțiune, tabul rămâne același și n-ar fi adus niciodată
			   în vizor — exact cazul „Descriere"/„Specificații" măsurat pe
			   Bathys. followActive() nu face nimic dacă tabul e deja vizibil,
			   deci apelul repetat e inofensiv; iar `userLocked` de mai jos
			   oprește orice mișcare cât timp utilizatorul trage el de bară. */
			if (current) followActive(current);
		}

		/* ── bara urmărește tabul activ (AM 2026-08-24, Tudor) ──
		   Pe mobil bara e mai îngustă decât conținutul ei: măsurat pe H95 la
		   375px, 343px vizibili din 545px, deci 202px — practic tot tabul
		   „Specificații tehnice" — stau în afara ecranului. Tabul se activa
		   corect la scroll, dar utilizatorul nu avea cum să vadă asta.

		   Se mută STRICT cât trebuie ca tabul activ să intre în cadru (cererea
		   lui Tudor: „pe măsură ce se dă scroll, bara să se mite la dreapta").
		   Dacă tabul e deja vizibil complet, bara nu se mișcă deloc — de-aia
		   nu sare pe „Monkey Deals"/„Documente utile", care încap oricum.

		   Clamparea la [0, maxScroll] nu e cosmetică: fără ea, primul tab cere
		   un delta negativ (marginea de 16px cade în afara zonei scrollabile)
		   și bara ar „trage" de capăt la fiecare activare. */
		/* Cât timp utilizatorul trage el de bară, nu i-o smucim înapoi.
		   Fereastra se reînnoiește la fiecare atingere/rotiță pe bară; după ce
		   ridică degetul, urmărirea automată revine. */
		var userLockedUntil = 0;
		/* `touchmove`/`pointermove`/`scroll` adăugate 2026-08-25 (review Codex):
		   fereastra de 2,5s se calcula doar la ÎNCEPUTUL gestului, deci o
		   tragere lentă sau inerţia de pe iOS care depăşea 2,5s rămânea
		   neprotejată, iar cronometrul de 600ms al spy-ului putea porni o
		   mişcare automată chiar sub degetul utilizatorului. Reînnoim la
		   fiecare semn de interacţiune, inclusiv scroll-ul propriu al barei. */
		['touchstart', 'touchmove', 'pointerdown', 'pointermove', 'wheel', 'scroll'].forEach(function (evt) {
			nav.addEventListener(evt, function () {
				userLockedUntil = Date.now() + 2500;
				if (animTimer) { clearInterval(animTimer); animTimer = null; }
			}, { passive: true });
		});

		/* Animator propriu de scrollLeft, pe setInterval (nu rAF).
		   `scrollTo({behavior:'smooth'})` NU e o opţiune: pagina are
		   `scroll-behavior: smooth` pe <html>, iar animaţia orizontală a barei
		   e anulată de fiecare dată când derulează pagina — adică exact când
		   rulează urmărirea asta. Măsurat pe Bathys: trei apeluri cu left≈202,
		   scrollLeft rămas 0; cu 'auto' sare imediat la 202. Acelaşi tipar e
		   deja documentat mai jos, la corecţia de drift pe verticală.

		   rAF ar fi fost varianta firească, dar nu rulează în tab-uri ascunse
		   (nici în harness-ul de verificare) — animaţia ar rămâne blocată la
		   primul cadru, cu bara oprită la jumătate. setInterval ţine ritmul şi
		   acolo, iar dacă intervalul e strangulat rezultatul e o săritură
		   directă la destinaţie, ceea ce e acceptabil.

		   `prefers-reduced-motion` sare direct la valoarea finală. */
		var animTimer = null;
		var animTarget = null;
		function animateScrollLeft(to) {
			/* Dacă deja alunecăm spre exact aceeaşi ţintă, NU repornim (review
			   Codex): followActive() e apelat din updateSpy(), adică la fiecare
			   frame de scroll ŞI din intervalul de 600ms. Repornirea la fiecare
			   apel resetează progresul, iar pe ecrane la 120Hz animaţia putea
			   să nu mai avanseze deloc. */
			if (animTimer && animTarget !== null && Math.abs(animTarget - to) < 1) return;
			if (animTimer) { clearInterval(animTimer); animTimer = null; }
			var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			var from = nav.scrollLeft;
			var dist = to - from;
			if (reduce || Math.abs(dist) < 2) { nav.scrollLeft = to; animTarget = null; return; }
			/* Progresul se calculează din timpul REAL scurs, nu din numărul de
			   tick-uri: un interval strangulat (tab în fundal) primea altfel
			   ~17 apeluri ca să termine, în loc să sară la destinaţie. */
			var DUR = 260, STEP = 16, t0 = Date.now();
			animTarget = to;
			animTimer = setInterval(function () {
				if (Date.now() < userLockedUntil) {   // utilizatorul are controlul
					clearInterval(animTimer); animTimer = null; animTarget = null; return;
				}
				var k = Math.min(1, (Date.now() - t0) / DUR);
				nav.scrollLeft = from + dist * (1 - Math.pow(1 - k, 3)); // ease-out cubic
				if (k >= 1) { clearInterval(animTimer); animTimer = null; animTarget = null; }
			}, STEP);
		}

		function followActive(tab) {
			if (Date.now() < userLockedUntil) return;
			var max = nav.scrollWidth - nav.clientWidth;
			if (max <= 0) return; // bara încape întreagă: nimic de urmărit
			var navR = nav.getBoundingClientRect();
			var tR = tab.getBoundingClientRect();
			var PAD = 16; // aceeași respirație ca padding-ul barei
			var delta = 0;
			if (tR.right > navR.right - PAD) delta = tR.right - (navR.right - PAD);
			else if (tR.left < navR.left + PAD) delta = tR.left - (navR.left + PAD);
			if (!delta) return;
			var want = Math.max(0, Math.min(max, nav.scrollLeft + delta));
			if (Math.abs(want - nav.scrollLeft) < 1) return;
			/* 'smooth' NU merge aici, şi nu din cauza preferinţelor de mişcare:
			   pagina are `scroll-behavior: smooth` pe <html>, iar animaţia
			   orizontală a barei e ANULATĂ de fiecare dată când pagina însăşi
			   derulează — adică exact tot timpul cât rulează urmărirea asta.
			   Măsurat pe Bathys: scrollTo({behavior:'smooth'}) se apela de trei
			   ori cu left≈202, iar scrollLeft rămânea 0; cu 'auto' sare la 202.
			   Acelaşi tipar e deja documentat mai jos, la corecţia de drift a
			   scroll-ului vertical („'instant' e obligatoriu la corecţie").
			   Animăm noi, cu rAF, ca să nu pierdem senzaţia de alunecare. */
			animateScrollLeft(want);
		}

		/* Un tab fără țintă pe pagină se ascunde. Condițiile Liquid sunt primul
		   filtru, dar nu garantează randarea secțiunii: „Review-uri" e cazul
		   real — metafieldul judgeme.widget există, dar NIMIC din temă nu
		   randează #judgeme_product_reviews, deci linkul era mort și în vechiul
		   meniu cu pastile (defect moștenit, descoperit la migrarea pe taburi;
		   și stelele de rating din main-product.liquid:125 pățesc la fel).
		   Se re-verifică târziu pentru că appurile își injectează containerele
		   async — dacă apare ținta, tabul revine. */
		function pruneMissing() {
			tabs.forEach(function (tab) {
				tab.style.display = resolveTarget(tab) ? '' : 'none';
			});
		}
		setTimeout(pruneMissing, 1500);
		setTimeout(pruneMissing, 6000);

		var ticking = false;
		function onScroll() {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(function () {
				updateSticky();
				updateSpy();
				ticking = false;
			});
		}
		/* AM26 2026-08-28 — resincronizarea offsetului, DOAR pe evenimente care
		   chiar schimbă geometria, nu la fiecare frame de scroll.

		   `updateSticky()` îngheaţă `top` în momentul lipirii (vezi comentariul
		   de acolo). Asta elimină alunecarea de pe iOS, dar înseamnă că o
		   schimbare LEGITIMĂ de înălţime a headerului — rotire în peisaj, bară
		   de anunţ închisă, breakpoint traversat — ar lăsa bara la un `top`
		   vechi. Aici o prindem: recalculăm o singură dată, la resize /
		   orientationchange, şi numai dacă bara chiar e lipită. */
		function refreshStickyOffset() {
			if (!nav.classList.contains('is-stuck')) return;
			nav.style.top = headerOffset() + 'px';
			spacer.style.height = nav.offsetHeight + 'px';
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', function () {
			refreshStickyOffset();
			onScroll();
		}, { passive: true });
		window.addEventListener('orientationchange', function () {
			/* după rotire, layoutul se stabilizează cu un frame întârziere */
			setTimeout(function () {
				refreshStickyOffset();
				onScroll();
			}, 100);
		}, { passive: true });
		/* Plasă de siguranță pe timer: prinde schimbările de poziție care nu
		   emit scroll (restaurarea scroll-ului de către browser, imagini lazy
		   care împing ancorele, secțiuni injectate async) și orice mediu în
		   care rAF nu rulează. Ieftin — două măsurători pe secundă. */
		setInterval(function () {
			updateSticky();
			updateSpy();
		}, 600);

		/* Scroll cu CORECȚIE DE DRIFT: rich description V3 e grea (video-uri,
		   imagini lazy) — conținutul de deasupra țintei crește ÎN TIMPUL
		   animației de scroll, deci y-ul calculat la click e deja vechi la
		   aterizare și utilizatorul ajunge cu secțiuni întregi mai sus. După
		   ce scroll-ul se așază (două eșantioane consecutive identice),
		   re-măsurăm ținta și corectăm instant dacă am deviat. 'instant' e
		   obligatoriu la corecție: pagina are scroll-behavior smooth, deci
		   'auto' ar porni ÎNCĂ o animație, care ar putea drifta și ea. */
		function targetY(el) {
			return el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - nav.offsetHeight - 12;
		}

		function scrollToTarget(el) {
			window.scrollTo({ top: targetY(el), behavior: 'smooth' });
			var last = -1, stable = 0, ticks = 0;
			var iv = setInterval(function () {
				ticks++;
				var cur = window.pageYOffset;
				if (Math.abs(cur - last) < 1) { stable++; } else { stable = 0; }
				last = cur;
				if (stable >= 2) {
					clearInterval(iv);
					var want = targetY(el);
					if (Math.abs(cur - want) > 24) {
						window.scrollTo({ top: want, behavior: 'instant' });
					}
				} else if (ticks > 30) {
					clearInterval(iv); // ~6s: renunțăm, nu ne batem cu userul pe scroll
				}
			}, 200);
		}

		/* ── click ── */
		tabs.forEach(function (tab) {
			tab.addEventListener('click', function (e) {
				var el = resolveTarget(tab);
				if (!el) return; // lasă browserul să încerce href-ul
				e.preventDefault();
				/* Ținta poate fi un acordeon închis (#tech-specs e .accordion-a cu
				   <details> — main-product.liquid:1334): deschide-l ÎNAINTE de a
				   calcula y, altfel utilizatorul aterizează pe un rând pliat. */
				var det = el.tagName === 'DETAILS' ? el : el.querySelector('details');
				if (det && !det.open) det.open = true;
				scrollToTarget(el);
				var href = tab.getAttribute('href');
				if (href && href.charAt(0) === '#') history.replaceState(null, '', href);
			});
		});

		pruneMissing();
		updateSticky();
		updateSpy();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
